export const addToCart = ({ commit }, product) => {
  commit('ADD_TO_CART', product)
}